import { ObjectMapper } from 'json-object-mapper';
import { IModel } from '../IModel';
import { Model } from '../model';

export class RecruitmentCandidatePositionModel
  extends Model
  implements IModel<RecruitmentCandidatePositionModel>
{
  public recruitmentId: string = '';
  public recruitmentCandidateId: string = '';
  public pipelineStageId: string = '';
  public pipelineStage: number = 0;
  public status: string = '';
  public commentary: string = '';
  public recruitRejectionReasonId: string = '';
  public recruitWithdrawalReasonId: string = '';
  public approvalDate: string | null = null;
  public withdrawnAt: string | null = null;
  public referredByEmployeeId: string = '';
  public referredByName: string = '';

  static create(input: any): RecruitmentCandidatePositionModel {
    if (!input) {
      return new RecruitmentCandidatePositionModel();
    }

    const position = ObjectMapper.deserialize(RecruitmentCandidatePositionModel, input);
    const normalizeString = (value?: any) => (value ? String(value).trim() : '');

    position.id = input.id || position.id;
    position.creationDate = input.creationDate || position.creationDate;
    position.changeDate = input.changeDate || position.changeDate;

    position.recruitmentId =
      normalizeString(position.recruitmentId) || normalizeString(input.recruitmentId);
    position.recruitmentCandidateId =
      normalizeString(position.recruitmentCandidateId) ||
      normalizeString(input.recruitmentCandidateId) ||
      normalizeString(input.candidateId);
    position.pipelineStageId =
      normalizeString(position.pipelineStageId) ||
      normalizeString(input.pipelineStageId) ||
      normalizeString(input.pipelineStage?.id);

    if (position.pipelineStage === 0 && input.pipelineStage !== undefined && input.pipelineStage !== null) {
      position.pipelineStage = Number(input.pipelineStage) || 0;
    }

    if (typeof input.status === 'object' && input.status !== null) {
      position.status = normalizeString(input.status.value || input.status.id);
    } else {
      position.status = normalizeString(input.status);
    }

    position.commentary = normalizeString(position.commentary) || normalizeString(input.commentary);
    position.recruitRejectionReasonId =
      normalizeString(position.recruitRejectionReasonId) ||
      normalizeString(input.recruitRejectionReasonId);
    position.recruitWithdrawalReasonId =
      normalizeString(position.recruitWithdrawalReasonId) ||
      normalizeString(input.recruitWithdrawalReasonId);
    position.approvalDate = input.approvalDate || position.approvalDate || null;
    position.withdrawnAt = input.withdrawnAt || position.withdrawnAt || null;
    position.referredByEmployeeId =
      normalizeString(position.referredByEmployeeId) ||
      normalizeString(input.referredByEmployeeId);
    position.referredByName =
      normalizeString(position.referredByName) ||
      normalizeString(input.referredByName);

    return position;
  }

  serialize(): any {
    return {
      id: this.id,
      recruitmentId: this.recruitmentId,
      recruitmentCandidateId: this.recruitmentCandidateId,
      pipelineStageId: this.pipelineStageId,
      pipelineStage: this.pipelineStage,
      status: this.status,
      commentary: this.commentary,
      recruitRejectionReasonId: this.recruitRejectionReasonId,
      recruitWithdrawalReasonId: this.recruitWithdrawalReasonId,
      referredByEmployeeId: this.referredByEmployeeId,
      referredByName: this.referredByName,
      withdrawnAt: this.withdrawnAt,
      creationDate: this.creationDate,
      changeDate: this.changeDate,
    };
  }
}